export enum PERFORMANCE_REPORT_KPI {
  CAMPAIGNS = 'campaigns',
  CLICKS = 'clicks',
  CLICKS_RATE = 'clicksRate',
  CONVERSION_RATE = 'conversionRate',
  CTR = 'ctr',
  DISMISSED_CLICKS = 'dismissedClicks',
  IMPRESSIONS = 'impressions',
  UNIQUE_IMPRESSIONS = 'uniqueImpressions',
  UNIQUE_CLICKS = 'uniqueClicks',
  IMPRESSIONS_RATE = 'impressionsRate',
  EVENTS = 'events',
}

export enum PERFORMANCE_REPORT_GROUP_BY {
  CAMPAIGN = 'campaign',
  MESSAGE_FORMAT = 'messageFormat',
  OS = 'os',
  APP_VERSION = 'appVersion',
  MESSAGE_TYPE_GROUP = 'messageTypeGroup',
  MESSAGE_CAMPAIGN_TYPE = 'messageCampaignType',
  CAMPAIGN_CATEGORY = 'campaignCategory',
}

export enum PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE {
  IMPACTS = 'impacts',
  CONVERSIONS = 'conversions',
}

export const EMPTY_LABEL = '__empty__';
export const OTHER_LABEL = '__other__';
